import { getPageLocaleUrl, stripPageRouteParam } from "./helpers";
import type { LanguageLike } from "./languageCode";

export type BreadcrumbPageLike = {
  pageType?: string;
  languageCode?: string;
  url?: string;
};

function ensureLeadingSlash(href: string): string {
  return href.charAt(0) === "/" ? href : `/${href}`;
}

function localeHomepageHref(lang: string): string {
  const code = lang?.trim() || "et";
  return `/${code}/`;
}

export function resolveProductBreadcrumbHomeHref(
  pages: BreadcrumbPageLike[],
  lang: string,
  languages?: LanguageLike[]
): string {
  const frontPage = pages.find(
    (page) => page.pageType === "frontPage" && page.languageCode === lang
  );
  if (frontPage) {
    return ensureLeadingSlash(
      stripPageRouteParam(getPageLocaleUrl(frontPage, languages))
    );
  }
  return localeHomepageHref(lang);
}

export function resolveProductBreadcrumbProductsHref(
  pages: BreadcrumbPageLike[],
  lang: string,
  languages?: LanguageLike[]
): string {
  const productsPage = pages.find(
    (page) => page.pageType === "products" && page.languageCode === lang
  );
  if (productsPage) {
    return ensureLeadingSlash(
      stripPageRouteParam(getPageLocaleUrl(productsPage, languages))
    );
  }
  return localeHomepageHref(lang);
}

export function buildProductBreadcrumbCategoryHref(
  productsBaseHref: string,
  categoryUuid: string
): string {
  return `${productsBaseHref}?category=${categoryUuid}`;
}
